import React from 'react';
import { useParams } from 'react-router-dom';
import { VALID_CITIES } from '../../../Utils/validCity';
import ErrorPage from '../../ErrorPage';

const ValidateRouteByCity = ({ Component }) => {
  const { sub, city } = useParams();
  const paramValue = sub || city; // support both /hotel/:sub and /experiences/:city

  const formattedCity = paramValue?.replace(/-/g, ' ').toLowerCase();
  const isValid = VALID_CITIES.some(
    valid => valid.toLowerCase() === formattedCity
  );

  // return isValid ? <Component city={formattedCity} /> : <ErrorPage />;
  return isValid ? <Component city={formattedCity} /> : <Component city={formattedCity} />;
};

export default ValidateRouteByCity;
